function e(e){return e.children}export{e as DefaultOverride};
//# sourceMappingURL=override.js.map